import { LanguageType } from "@/custom-types";
import { PaymentFrequencyOption } from "@/graphql/generated";

export const paymentFrequencyMapper = (frequency: PaymentFrequencyOption | null | undefined, language: LanguageType) => {
  if (!frequency) return language === 'es' ? 'No disponible' : 'Not available';

  const freqMap = {
    en: {
      MONTHLY: 'Monthly',
      QUARTERLY: 'Quarterly',
      SEMIANNUALLY: 'Semiannually',
      YEARLY: 'Yearly'
    },
    es: {
      MONTHLY: 'Mensual',
      QUARTERLY: 'Trimestral',
      SEMIANNUALLY: 'Semestral',
      YEARLY: 'Anual'
    },
  };
  return freqMap[language][frequency];
};
